export default __webpack_public_path__ + "static/media/gsuite-negative.018dbf06.svg";